/** Інший запис події зв'язку (linked, unlinked) у стрічці історії. */
import type { IHistoryEntry } from '@platform/core/types';
import type { IHistoryLinkTarget } from './IHistoryLinkTarget';

/**
 * Запис, з яким зв'язали чи від якого відв'язали: конверт події (otherRecordType, otherModule, otherDisplay, otherTitle) — для посилання
 * «код назва» на його сторінку; без конверта (старіша відповідь API) чи для подій іншого виду — null, і стрічка показує лише otherRecordId.
 * Чиста функція.
 */
export function historyLinkTarget(entry: IHistoryEntry): IHistoryLinkTarget | null {
  if (entry.kind !== 'linked' && entry.kind !== 'unlinked') return null;
  const { otherRecordId: id, otherModule: module, otherRecordType: recordType, otherDisplay: display } = entry;
  if (!id || !module || !recordType || !display) return null;
  return { id, module, recordType, display, title: entry.otherTitle ?? '' };
}
